export default __webpack_public_path__ + "static/media/move_CONTAINER.5907ddf5.svg";